<template>
  <v-container>
    <v-card>
      <v-card-title>Setting</v-card-title>
      <v-card-text>
        <v-layout>
          App Version
          <v-spacer />
          {{ appVersion }}
        </v-layout>
        <v-divider />
        <v-layout>
          ログインユーザ
          <v-spacer />
          {{ user.username }}
        </v-layout>
        <v-divider />
        <v-layout>
          デフォルト店舗
          <v-spacer />
          {{ shop.name }}
        </v-layout>

        <v-radio-group v-model="modeModel" row>
          <v-radio label="店内予約" :value="1" />
          <v-radio label="店頭予約" :value="2" />
        </v-radio-group>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :to="{
            path: '/',
          }"
          replace
          >TOPに戻る</v-btn
        >
        <v-spacer />
        <v-btn
          color="primary"
          :disabled="!swRegistered"
          :loading="updating"
          @click="update"
          >app update</v-btn
        >
        <v-btn color="primary" @click="dialog = true">店舗変更</v-btn>
        <v-btn color="primary" @click="logout">logout</v-btn>
      </v-card-actions>
    </v-card>
    <ShopSelectionDialog
      v-model="dialog"
      :shop="shop"
      @update:shop="updateShop"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import pkg from '@/../package.json'
import ShopSelectionDialog from '@/components/ShopSelectionDialog'

export default {
  name: 'SettingView',
  components: {
    ShopSelectionDialog,
  },
  data: () => ({
    dialog: false,
    updating: false,
  }),
  computed: {
    ...mapGetters(['user', 'shop', 'mode', 'swRegistered', 'swUpdated']),
    appVersion() {
      return pkg.version
    },
    modeModel: {
      get() {
        return this.mode
      },
      set(value) {
        this.setMode(value)
      },
    },
  },
  methods: {
    ...mapActions(['clear', 'setShop', 'setMode']),
    logout() {
      this.clear()
      this.$router.push({
        path: '/login',
        query: {
          mode: this.$route.query.mode,
        },
      })
    },
    updateShop(shop) {
      this.setShop(shop)
      this.dialog = false
    },
    async update() {
      this.updating = true
      const registration = await navigator.serviceWorker.getRegistration()
      if (!this.swUpdated) await registration.update()
      await registration.unregister()
      document.location.reload(true)
      this.updating = false
    },
  },
}
</script>

<style></style>
